"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allChains = exports.getChain = exports.getChainByName = exports.getChainById = exports.ChainId = exports.ChainName = void 0;
var chains_1 = require("./chains");
var enums_1 = require("./enums");
Object.defineProperty(exports, "ChainName", { enumerable: true, get: function () { return enums_1.ChainName; } });
Object.defineProperty(exports, "ChainId", { enumerable: true, get: function () { return enums_1.ChainId; } });
/**
 * Get a chain by its `id`.
 * @param id - The `id` of the chain
 * @returns The `Chain` object associated with the chain `id`
 */
var getChainById = function (id) { return chains_1.chains[id]; };
exports.getChainById = getChainById;
/**
 * Get a chain by its `name`.
 * @param name - The `name` of the chain
 * @returns The `Chain` object associated with the chain `name`
 */
var getChainByName = function (name) {
    return Object.values(chains_1.chains).find(function (chain) { return chain.name === name; }) || {};
};
exports.getChainByName = getChainByName;
/**
 * Get a chain by its `id` or by its `name`.
 * @param idOrName - The name or id of the chain
 * @returns The `Chain` object associated with the `id` or `name`
 */
var getChain = function (idOrName) {
    return typeof idOrName === 'number' ? exports.getChainById(idOrName) : exports.getChainByName(idOrName);
};
exports.getChain = getChain;
/**
 * Gets the entire `chains` object
 * @returns An object containing all chains
 */
var allChains = function () { return chains_1.chains; };
exports.allChains = allChains;
